import {
    FETCH_ORDER_FAILURE,
    FETCH_ORDER_SUCCESS,
    FETCH_USERINFO_FAILURE,
    FETCH_USERINFO_SUCCESS,
    FETCH_ORDER_REQUEST,
    FETCH_USER_REQUEST,
    FETCH_CURRENTBALANCE_REQUEST,
    FETCH_CURRENTBALANCE_SUCCESS,
    FETCH_CURRENTBALANCE_FAILURE,
    FETCH_CANCEL_REQUEST,
    FETCH_CANCEL_SUCCESS,
    FETCH_CANCEL_FAILURE
} from "./actionTypes";

import { TodoActions, TodoState } from "./types";

const initialState: TodoState = {
    pending: false,
    userResult: [],
    orderResult:[],
    totalPageOrder: 0,
    totalPageUser: 0,
    error: null,
    currentBalance: null,
    loading: null,
    planPackage:[],
};

const toUserReducer = (state = initialState, action: TodoActions) => {
    switch (action.type) {
        case FETCH_ORDER_REQUEST:
            return {
                ...state,
                pending: true,
                loading:"loading"
            };
        case FETCH_ORDER_SUCCESS:
            return {
                ...state,
                pending: false,
                orderResult: action.payload.orderResult,
                totalPageOrder: action.payload.totalPageOrder,
                error: null,
                loading: null
            };
        case FETCH_ORDER_FAILURE:
            return {
                ...state,
                pending: false,
                orderResult: [],
                error: action.payload.error,
                loading: null
            };
        case FETCH_USER_REQUEST:
            return {
                ...state,
                pending: true,
                loading: "loading"
            };
        case FETCH_USERINFO_SUCCESS:
            return {
                ...state,
                pending: false,
                userResult: action.payload.userResult,
                totalPageUser: action.payload.totalPageUser,
                error: null,
                loading: null
            };
        case FETCH_USERINFO_FAILURE:
            return {
                ...state,
                pending: false,
                userResult: [],
                error: action.payload.error,
                loading: null
            };
        case FETCH_CURRENTBALANCE_REQUEST:
            return {
                ...state,
                pending: true,
                orderResult: []
            }
        case FETCH_CURRENTBALANCE_SUCCESS:
            return {
                ...state,
                pending: false,
                currentBalance: action.payload.currentBalance.currentBalance,
                planPackage: action.payload,
                error: null
            }
        case FETCH_CURRENTBALANCE_FAILURE:
            return {
                ...state,
                pending: false,
                error: action.payload.error,
                currentBalance: null,
            }
            case FETCH_CANCEL_REQUEST:
                return {
                    ...state,
                    pending: true,
                }
            case FETCH_CANCEL_SUCCESS:
                return {
                    ...state,
                    pending: false,
                }
            case FETCH_CANCEL_FAILURE:
                return {
                    ...state,
                    pending: false,
                    error: action.payload.error,
                }
        default:
            return {
                ...state,
            };
    }
};

export default toUserReducer;
